import * as React from 'react';
import { Location } from 'types/location.type';
import { Box, ClickAwayListener, IconButton, Popper } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';
import { LabeledData } from '../../Input';
import { formatDollar } from '../../../helpers/formatters';

interface Props {
    location?: Location;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            boxShadow: '0 7px 20px 0 rgba(0,0,0,0.08)',
            borderRadius: '8px',
            padding: theme.spacing(1),
            backgroundColor: theme.palette.background.paper,
        },
    })
);

const GLScoreInfo: React.FunctionComponent<Props> = (props) => {
    const { location } = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const classes = useStyles();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    return (
        <>
            <IconButton size={'small'} style={{ marginTop: 15, marginLeft: 5, width: 20 }} onClick={handleClick}>
                <InfoIcon fontSize={'small'} />
            </IconButton>

            <Popper open={open} anchorEl={anchorEl}>
                <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                    <div className={classes.paper}>
                        <LabeledData
                            title={'Avg Rents'}
                            value={location?.averageRents ? formatDollar(location.averageRents) : 'N/A'}
                        />
                        <LabeledData title={'Yr Const'} value={location?.yearOfConstruction || 'N/A'} />
                    </div>
                </ClickAwayListener>
            </Popper>
        </>
    );
};

export default GLScoreInfo;
